import React,{Component} from 'react';
import Button from '@mui/material/Button';
import ReactDOM from 'react-dom';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';

class AttachmentUpload extends Component
{
    state=
    {
        uploading:false,
        fileName:""
    };
    openFileDialog =()=> {
        var fileInputDom = ReactDOM.findDOMNode(this.refs.fileUpload)
        fileInputDom.click()
      }
      handleFile=(event)=>
      {
        if(event.target.files&&event.target.files.length)
        {
            this.setState({uploading:true,fileName:event.target.files[0].name});
            const formData= new FormData();
            formData.append(this.props.name, event.target.files[0], event.target.files[0].name);
            this.props.onUpload(formData).then(uploadedFile=>
                {
                    if(!this.props.handled) {
                        this.setState({file:uploadedFile,uploading:false});
                    } else {
                        
                    }
                    this.props.onChange({path:uploadedFile,filename:this.state.fileName});
                    this.setState({fileName:"",uploading:false});
                },error=>
                {
                    this.setState({file:"",fileName:"",uploading:false});
                    this.props.onError();
                }).catch(error=>
                    {
                        this.setState({file:"",fileName:"",uploading:false});
                        this.props.onError();
                    });
        }
      }
    render()
    {
        return (
            <div>
                {this.state.uploading&&<div className="upload-status"><div class="spinner-border spinner-border-sm" role="status">
  <span class="sr-only">Loading...</span>
</div> Uploading file...</div>}
               
              {!this.state.uploading&&<div onClick={this.openFileDialog}>{this.props.children}
              <input
                type='file'
                multiple={this.props.multi}
                ref='fileUpload'
                style={{ display: 'none' }}
                accept={this.props.accept}
                onChange={this.handleFile} />
            </div>}
            </div>
          );
    }
    
}

export default AttachmentUpload;